export default __webpack_public_path__ + "static/media/building.e3c3fc9c.png";